import { createPluginFactory } from "@udecode/plate";

export const REDO_PLUGIN = "redo";

export const createRedoPlugin = createPluginFactory({
  key: REDO_PLUGIN,
  isVoid: true,
});
